import { jsx as e, jsxs as t } from "react/jsx-runtime";
import { useRef as i, useState as r, useCallback as n, useEffect as o } from "react";
import { Stack as l, Typography as m, styled as c } from "@mui/joy";
import { Tooltip as h } from "@mui/material";
const f = c("span")(({ theme: e2 }) => ({ color: e2.palette.neutral[600], fontSize: "0.7em" })), s = ({ fontSize: c2 = "md", text: s2, unit: a }) => {
  const d = i(null), [p, x] = r(false), u = n((e2) => e2 && e2.scrollWidth > e2.clientWidth, []);
  return o(() => {
    x(u(d.current));
  }, [s2, a, u]), e(h, { title: `${s2}, ${a}`, disableHoverListener: !p, children: t(l, { direction: "row", alignItems: "baseline", sx: { maxWidth: "100%", fontSize: (e2) => e2.fontSize[c2] }, children: [e(m, { ref: d, fontWeight: 500, sx: { fontSize: "inherit", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }, textColor: "neutral.700", children: s2 }), !!a && e(m, { sx: { fontSize: "inherit" }, children: ", " }), e(m, { sx: { fontSize: "inherit" }, children: e(f, { children: a }) })] }) });
};
export {
  s as HeaderWithUnits
};
//# sourceMappingURL=HeaderWithUnits.js.map
